import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractBlogInstructions(
    $sectionId: ID!
    $url: String!
    $headline: String
    $projectId: ID
  ) {
    extractBlogInstructions(
      sectionId: $sectionId
      url: $url
      headline: $headline
      projectId: $projectId
    ) {
      id
    }
  }
`;

export const extractBlogInstructionsBasedOnURL = async (
  sectionId: ID,
  url: string,
  headline: string,
  projectId: ID
) => {
  const variables = { sectionId, url, headline, projectId };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Entity>(result.data);
};
